import React from 'react';
import FortisButton from '../../../components/Basic/FortisButton';
import { browserHistory } from 'react-router';
const Logout = () => {
  return (
   <div className="row">
    <div className="col-sm-12">
        <hr className="soften" />
        <h3 className="text-warning" style={{ "color": "#f4ae11;"}}>You are now logged out</h3>       
        <h4>Thank you for using the online service request tool. <a href="http://www.fortisbc.com">Return to our website</a>.</h4>   
        <div className="form-group">
            <a  onClick={() => browserHistory.push('/login')}> <FortisButton text="LOG IN"/> </a>    
            <br/>      
             <br/>          
        </div>
      
        <hr className="soften" style={{ "clear": "left;"}}/>
    </div>
</div>
  );
};
export default Logout;
    
